import { useTranslation } from "react-i18next";
import { GET_TIME_ENTRIES } from "../../../../../graphql/timeEntry";
import useLazyQueryAuth from "../../../../../hooks/useLazyQueryAuth";
import { Dialog, Grid, IconButton } from "@mui/material";
import { Title } from "../../../../../components/Titles/FormTitles";
import AttendanceByEmployee from "../../MyTimesheet";
import colors from "../../../../../assets/theme/light/colors";
import { useState } from "react";

function MultipleEntriesDrawer({
openModal,
closeModal
}) {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState([]);
  const {
    refetch: refetchData,
  } = useLazyQueryAuth(GET_TIME_ENTRIES, "GetTimeEntries");

    return(
        <>
        <Dialog
          open={openModal}
          onClose={(event, reason) => {
            if (reason !== "backdropClick") {
              closeModal();
            }
          }}
          sx={{
            ".MuiDialog-paper": {
              maxHeight: "100% !important",
              minWidth: "95% !important",
              padding: "6px 30px !important",
              backgroundColor: `${colors.grey_background}`,
            },
          }}
        >
          <Grid container alignItems="center">
            <Grid
              item
              sm={10}
              lg={10}
              md={10}
              xs={10}
              xl={10}
              p={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid item mr={1} sx={{ display: "flex", alignItems: "center" }}>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-chart-infographic"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  strokeWidth="1.8"
                  stroke="#344767"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                  <path d="M7 3v4h4" />
                  <path d="M9 17l0 4" />
                  <path d="M17 14l0 7" />
                  <path d="M13 13l0 8" />
                  <path d="M21 12l0 9" />
                </svg>
              </Grid>
              <Title style={{ marginTop: "5px" }}>{t("dialog.ts.title")}</Title>
            </Grid>
            <Grid
              item
              sm={2}
              lg={2}
              md={2}
              xs={2}
              xl={2}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <IconButton
               onClick={closeModal}
                sx={{ fontSize: "14px !important" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-x"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="1"
                  stroke="#9e9e9e"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M18 6l-12 12" />
                  <path d="M6 6l12 12" />
                </svg>
              </IconButton>
            </Grid>
          </Grid>
          <Grid mt={-1} item pb={2}>
            <AttendanceByEmployee
              fromNav
              handleCloseTimesheet={closeModal}
              refetchData={refetchData}
              handleDate={(d) => setSelectedDate(d)}
            />
          </Grid>
        </Dialog>
        </>
    )
}

export default MultipleEntriesDrawer